import script from "./Boxs.vue?vue&type=script&setup=true&lang=js"
export * from "./Boxs.vue?vue&type=script&setup=true&lang=js"

import "./Boxs.vue?vue&type=style&index=0&id=b893202e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b893202e"]])

export default __exports__